/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {

};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.AddTimeVideoQuestionsAction.REQUEST_ADDTIMEVIDEOQUESTION:
      return {
        ...state,
    };
    case actions.AddTimeVideoQuestionsAction.ADDTIMEVIDEOQUESTION_RECEIVED:
          return{
      ...state,
    };

    default:
      return state;
  }
};

export default reducer;
